export default "__VITE_ASSET__rHS4UCiJ0eFSW8ru4CFNMg__"